class DetectDevice {
  constructor() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent)) {
        var device =  "android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(navigator.platform) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) {
        var device =  "ios";
    }

    if(!device) {
      var device = "desktop"
    }

    document.body.classList.add('device--'+device)
  }
}

new DetectDevice();
